import { getFirebase } from "react-redux-firebase";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "../modules";


export const addPhoneInvite = ({projectId, phoneNumber, name}: {projectId:string, phoneNumber: string, name: string}) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const userInvitesRef = firebase.database().ref('/user_invites');
        const newUserInvitesKey = userInvitesRef.push().key

        return firebase.database().ref(`/user_invites/${newUserInvitesKey}`).set({
            project_uid: projectId,
            phoneNumber,
            name,
            createdAt: firebase.database.ServerValue.TIMESTAMP
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/sharelink.actions.ts